import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ResourceModel } from 'projects/core/src/lib/models/resource.model';
import * as FileSaver from 'file-saver';
import {
  faFileAlt,
} from '@fortawesome/pro-light-svg-icons';
import { TranslocoService } from '@ngneat/transloco';
import { CandidateAcOnlinetestModel } from 'projects/core/src/lib/models/candidate-ac-onlinetest.model';
import { AcModel } from 'projects/runner/src/app/models/ac.model';
import { RunnerOnlinetestModel } from 'projects/runner/src/app/models/runner-onlinetest.model';
import { CandidateModel } from 'projects/runner/src/app/models/candidate.model';
import { AuthStateService } from 'projects/runner/src/app/services/auth-state.service';
import { ApiService } from 'projects/runner/src/app/services/api.service';
import { UiService } from 'projects/runner/src/app/services/ui.service';

const FILE_TYPE = 'onlinetest.report';

@Component({
  selector: 'app-onlinetest-nav',
  templateUrl: './onlinetest-nav.component.html',
  styleUrls: ['./onlinetest-nav.component.scss']
})
export class OnlinetestNavComponent implements OnInit, OnChanges {

  @Input() ac: AcModel;
  @Input() onlinetest: RunnerOnlinetestModel;
  @Input() candidate: CandidateModel;

  public loading = false;
  public otCandidate: CandidateAcOnlinetestModel = null;
  public faFileAlt = faFileAlt;

  constructor(
    private api: ApiService,
    private ui: UiService,
    public auth: AuthStateService,
    public transloco: TranslocoService
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.candidate && this.onlinetest) {
      this.otCandidate = this.onlinetest.candidates.find(candidate => candidate.hashed_id === this.candidate.hashed_id) || null;
    }
  }

  public downloadFile(resource: ResourceModel): void {
    if (resource.hasRight(this.auth.getUserType())) {
      this.api
        .downloadFile(
          FILE_TYPE,
          this.otCandidate.id,
          resource.id
        )
        .subscribe({
          next: (response: any) => {
            const blob = new Blob([response]);
            FileSaver.saveAs(blob, resource.public_name);
          }
        });
    }
  }

  public loadReports(): void {
    this.loading = true;
    this.api.getReports().subscribe({
      next: (result) => {
        const newFiles = this.ac.setNewOnlinetestReports(result.data);
        if (newFiles === 1) {
          this.ui.toastSuccess(this.transloco.translate('onlinetest.messages.new_one_loaded'));
        } else if (newFiles > 1) {
          this.ui.toastSuccess(this.transloco.translate('onlinetest.messages.new_multiple_loaded', { newFiles }));
        } else {
          this.ui.toastInfo(this.transloco.translate('onlinetest.messages.no_reports_found'));
        }
      },
      error: () => {
        this.ui.toastInfo(this.transloco.translate('onlinetest.messages.no_reports_available'));
      }
    }).add(() => {
      this.loading = false;
    });
  }

}
